/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Google_UnlinkInputs */

const cs_settings_google_unlink = /** @type {(inputs: Settings_Google_UnlinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odpojit Google účet`)
};

const en_settings_google_unlink = /** @type {(inputs: Settings_Google_UnlinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlink Google account`)
};

/**
* | output |
* | --- |
* | "Unlink Google account" |
*
* @param {Settings_Google_UnlinkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_google_unlink = /** @type {((inputs?: Settings_Google_UnlinkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Google_UnlinkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_google_unlink(inputs)
	return cs_settings_google_unlink(inputs)
});